import { useMutation } from "urql";

import { CreateWaiveDocument } from "../../../graphql/generated.ts";

export function useCreateWaive() {
  return useMutation(CreateWaiveDocument);
}
